import {IAiBuilderState} from "../reducers/ai-builder.reducer";
import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {AiBuilderDataMapper} from "../../websites/website/ai-builder/ai-builder-mapper";
import {TypeUtils} from "../../shared/utils/type-utils";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCreatedPagesState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.aiBuilder);

export const getCreatedPages = (websiteId: number) => createSelector(getCreatedPagesState,
  (state: IAiBuilderState) => {
    if (state.entities[websiteId] && TypeUtils.isDefined(state.entities[websiteId].entities) && state.entities[websiteId].entities[1]) {
      const recordsMap = Object.values(state.entities[websiteId].entities).map((record: any) => {
        record = AiBuilderDataMapper.map(record);
        return record;
      });
      return Object.values(recordsMap);
    }
    else return [];
  }
);

export const getRegenerationCount = (websiteId: number) => createSelector(getCreatedPagesState,
  (state: IAiBuilderState) => {
    if (state.entities[websiteId] && !!state.entities[websiteId].entities) {
      // @ts-ignore
      return state.entities[websiteId].entities.regeneration_count || 0;
    }
    return 0;
  }
);

export const getCreatedPagesMap = (websiteId: number) => createSelector(getCreatedPagesState,
  (state: IAiBuilderState) =>
    state.entities[websiteId]
);

export const getCreatedPage = (websiteId: number) => createSelector(getCreatedPagesState,
    (state: IAiBuilderState) =>
      state.entities[websiteId]
);

export const getCreatedPagesLoading = (websiteId: number) => createSelector(getCreatedPagesState,
  (state: IAiBuilderState) =>
    state.entities[websiteId].loading
);

export const getCreatedPagesLoaded = (websiteId: number) => createSelector(getCreatedPagesState,
  (state: IAiBuilderState) =>
    state.entities[websiteId] ? state.entities[websiteId].loaded : false
);

export const getGeneratedWebsitesCount =  createSelector(getCreatedPagesState,
  (state: IAiBuilderState) => state.generatedWebsiteCount
);

export const getRegeneratePermission =  createSelector(getCreatedPagesState,
  (state: IAiBuilderState) => state.canRegenerate
);
